import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/storesRequisition'

/** 领料单分页列表 */
export const storesRequisitionPage = (params) => {
  return axios.get(`${rootApi}/page`, {params})
}

/** 领料单详细实体查询 */
export const getStoresRequisitionModel = (id) => {
  return axios.get(`${rootApi}/${id}/model`)
}